import Vue from 'vue';

class NotificationService {

  constructor() {
    this.group = 'notifications';
    this.NOTIFY_TYPE = Object.freeze({
      SUCCESS: 'success',
      ERROR: 'error',
      WARNING: 'warn'
    });
  }

  success (message) {
    Vue.prototype.$notify({
      group: this.group,
      text: message,
      type: this.NOTIFY_TYPE.SUCCESS
    });
  }

  error (message) {
    Vue.prototype.$notify({
      group: this.group,
      text: message,
      type: this.NOTIFY_TYPE.ERROR
    });
  }

  warning (message) {
    Vue.prototype.$notify({
      group: this.group,
      text: message,
      type: this.NOTIFY_TYPE.WARNING
    });
  }
}

export default NotificationService;
